require('prismjs/themes/prism-coy.css')
import './src/styles/global.css'
